
<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Edycja danych Hiperio
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxLayout="row">
      <mat-slide-toggle [formControl]="hiperioBlockedAccountControl" color="accent">Konto zablokowane</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest "
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
